import React from 'react'
import Header from '../Components/Header/Header'
import Allcard from '../Components/FlashCard/Allcard'

function AllCards() {
  return (
    <div>
        <Header/>
        <Allcard/>
    </div>
  )
}

export default AllCards